var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{staticClass:"d-flex align-center justify-center",attrs:{"height":"30","type":"heading"}})
}
var staticRenderFns = []

export { render, staticRenderFns }